<template>
  <div class="app-container">
    <nav class="add-navigation">
      <div
        @click="$router.push({ name: 'system-admin-admin-list' })"
        class="back-link"
      >
        <svg
          class="icon"
          width="30px"
          height="30px"
          viewBox="0 0 30 30"
          version="1.1"
        >
          <path
            d="M9.82106781,14.25 L23,14.25 L23,16.25 L9.84421387,16.25 L11.6568542,18.0626404 L10.2426407,19.4768539 L7.41842728,16.6526405 L7.41421356,16.6568542 L7.00735931,16.25 L7,16.25 L7,16.2426407 L6,15.2426407 L6.00421371,15.238427 L6,15.2342133 L7.41421356,13.8199997 L7.41842728,13.8242134 L10.2426407,11 L11.6568542,12.4142136 L9.82106781,14.25 Z"
            id="path-1"
          />
        </svg>
        <p>Back to Admins</p>
      </div>
      <div class="buttons-wrapper">
        <div
          @click="$router.push({ name: 'system-admin-admin-list' })"
          class="secondary-button"
        >
          <secondary-button>Cancel</secondary-button>
        </div>
        <div class="primary-button">
          <primary-button @click.native="addAdmin">Add Admin</primary-button>
        </div>
      </div>
    </nav>
    <loader :loading="loading" v-if="loading" />
    <div class="add-container" v-else>
      <span class="container-title">Add Admin</span>
      <div class="col-wrapper">
        <div class="col">
          <primary-input
            type="text"
            name="first name"
            class="field"
            :value="contact.first_name"
            @input="handleFirstName"
            v-validate="'required'"
            :class="{ input: true, 'is-danger': errors.has('first name') }"
            placeholder="Enter first name"
          />
          <div class="help is-danger" v-if="errors.has('first name')">
            {{ errors.first("first name") }}
          </div>
          <div class="help is-danger" v-if="contactError">
            {{ contactError.first_name ? contactError.first_name[0] : null }}
          </div>
          <primary-input
            type="text"
            name="user name"
            v-model="contact.user_name"
            v-validate="'required'"
            :class="{ input: true, 'is-danger': errors.has('user name') }"
            placeholder="Enter username"
          />
          <div class="help is-danger" v-if="errors.has('user name')">
            {{ errors.first("user name") }}
          </div>
          <div class="help is-danger" v-if="contactError">
            {{ contactError.user_name ? contactError.user_name[0] : null }}
          </div>
          <primary-input
            type="password"
            name="password"
            v-model="contact.passwd"
            v-validate="'required'"
            ref="password"
            :class="{ input: true, 'is-danger': errors.has('password') }"
            placeholder="********"
          />
          <div v-if="errors.has('password')" class="help is-danger">
            {{ errors.first("password") }}
          </div>
          <div class="help is-danger" v-if="contactError">
            {{ contactError.password ? contactError.password[0] : null }}
          </div>
          <!-- <primary-select
            type="text"
            name="role"
            v-validate="'required'"
            v-model="contact.rank"
            :class="{'input': true, 'is-danger': errors.has('role')}"
            placeholder="Role"
          >
            <option v-for="(i, k) in role" :value="i" :key="k">{{i}}</option>
          </primary-select>
          <div v-if="errors.has('role')" class="help is-danger">{{ errors.first('role') }}</div>-->
          <div class="help is-danger" v-if="contactError">
            {{ contactError.role ? contactError.role : null }}
          </div>
        </div>
        <div class="col">
          <primary-input
            type="text"
            name="last name"
            :value="contact.last_name"
            @input="handleLastName"
            v-validate="'required'"
            :class="{ input: true, 'is-danger': errors.has('last name') }"
            placeholder="Enter last name"
          />
          <div v-if="errors.has('last name')" class="help is-danger">
            {{ errors.first("last name") }}
          </div>
          <div class="help is-danger" v-if="contactError">
            {{ contactError.last_name ? contactError.last_name[0] : null }}
          </div>
          <primary-select
            class="input"
            name="status"
            v-validate="'required'"
            v-model="contact.is_active"
            :options="[
              { name: 'active', value: true },
              { name: 'inactive', value: false },
            ]"
          />
          <div v-if="errors.has('status')" class="help is-danger">
            {{ errors.first("status") }}
          </div>
          <div class="help is-danger" v-if="contactError">
            {{ contactError.status ? contactError.status[0] : null }}
          </div>
          <primary-input
            type="password"
            name="re-enter password"
            v-validate="'required|confirmed:password'"
            data-vv-as="password"
            v-model="checkPassowrd"
            :class="{
              input: true,
              'is-danger': errors.has('re-enter password'),
            }"
            placeholder="********"
          />

          <div class="help is-danger" v-if="errors.has('re-enter password')">
            {{ errors.first("re-enter password") }}
          </div>
          <div class="help is-danger" v-if="contactError">
            {{
              contactError.re - enter_password
                ? contactError.re - enter_password[0]
                : null
            }}
          </div>
        </div>
        <!-- <div class="col">
          <p class="pimary-input-title">Change Photo</p>
          <app-dropzone @fileAdd="fileAdded($event)" @remove="fileRemoved($event)"></app-dropzone>
        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    PrimaryInput: () => import("@/components/Inputs/PrimaryInput.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
    AppDropzone: () => import("@/components/Dropzone"),
    Loader: () => import("@/components/Loader.vue"),
  },
  data: () => ({
    contactError: null,
    role: ["Admin", "User"],
    contact: {
      user_name: null,
      last_name: null,
      passwd: null,
      first_name: null,
      is_admin: true,
      is_active: true,
    },
    loading: false,
    file: null,
    checkPassowrd: null,
  }),
  created() {},
  methods: {
    handleFirstName(v) {
      this.contact.first_name = this.$capitalize(v);
    },
    handleLastName(v) {
      this.contact.last_name = this.$capitalize(v);
    },
    addAdmin: async function () {
      const valid = await this.$validator.validate();

      if (!valid) {
        return;
      }

      try {
        await this.$store.dispatch("AddUser", {
          user: this.contact,
        });
        this.loading = true;
        const promiseLoader = new Promise((resolve, reject) => {
          setTimeout(() => {
            resolve();
            this.loading = false;
          }, 500);
        });
        promiseLoader.then(() => {
          this.$snotify.success("Admin have been added.", {
            timeout: 6000,
          });

          this.$router.push({ name: "system-admin-admin-list" });
        });
      } catch (err) {
        if (err.errors) {
          this.contactError = err.errors[0].contact
            ? err.errors[0].contact
            : null;
          setTimeout(() => {
            this.contactError = null;
          }, 6000);
        } else if (err.response) {
          this.$snotify.error(
            err.response.data.errors
              ? err.response.data.errors
              : err.response.data.error.message,
            { timeout: 6000 }
          );
        } else {
          this.$snotify.error(err, { timeout: 6000 });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.app-container {
  font-family: "Helvetica Neue";
  padding: 0 20px;
  .add-navigation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    width: 100%;
    margin-top: 20px;
    margin-bottom: 20px;
    .back-link {
      cursor: pointer;
      display: flex;
      align-items: center;
      fill: #51a3f3;
      color: #51a3f3;
      font-family: "Helvetica Neue";
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      p {
        margin-bottom: 0;
      }
    }
    .buttons-wrapper {
      display: flex;
      align-items: center;
      width: fit-content;
      .primary-button {
        height: 40px;
        width: 140px;
      }
      .secondary-button {
        height: 40px;
        width: 90px;
        margin-right: 20px;
      }
    }
  }
  .add-container {
    flex-direction: column;
    align-items: center;
    height: fit-content;
    background-color: #ffffff;
    padding-top: 15px;
    .container-title {
      height: 30px;
      width: 432px;
      color: #000000;
      font-size: 16px;
      font-weight: 500;
      line-height: 30px;
      padding: 15px 0 15px 15px;
    }
    .col-wrapper {
      width: 100%;
      display: flex;
      justify-content: space-between;
      margin-left: 15px;
      margin-top: 20px;
      .col {
        width: 100%;
        margin-right: 15px;
        padding-left: 0;
        .input {
          margin-bottom: 20px;
        }
        .field {
          p.pimary-input-title {
            color: #000000;
            font-family: "Helvetica Neue";
            font-size: 12px;
            font-weight: 900;
          }
        }
        .pimary-input-title {
          color: #000000;
          font-family: "Helvetica Neue";
          font-size: 12px;
          font-weight: 900;
          letter-spacing: 0.21px;
          line-height: 15px;
          margin-bottom: 5px;
          text-transform: uppercase;
        }
      }
    }
    .email-input {
      margin-bottom: 20px;
    }
    .password-input {
      margin-bottom: 30px;
    }
    .first {
      margin-bottom: 30px;
      .remember-me {
        display: flex;
        align-items: center;
        input {
          margin-right: 5px;
        }
      }
    }
  }
}
</style>

